import columnIndexToName from '@common/xlsxExport/utils/columnIndexToName';

export const VALIDATION_ERRORS = {
  WORKSHEET_WIDTH: 'The import resulted in 0 records imported. Please examine the Excel import file and try again.',
  COLUMN_HEADERS: () => 'An error occurred importing the file. Please examine column headers.',
  COLUMN_HEADER_ERROR: column => `An error occurred importing the file. Please examine column ${columnIndexToName(column - 1)}.`,
  EMPTY_ROWS_ERROR: () => 'The import resulted in 0 records imported. Blank rows are not allowed in the import file.',
  NOT_EXCEL_FILE: () => 'File selected is not an Excel file (.xls or .xlsx). Please select an Excel file to import.',
  PRIOR_PERIOD_ERROR: () => 'Invalid Period in the Excel file data. Please examine the Period column and try again.',
};
